module.exports = __webpack_public_path__ + "img/Souq Jinan.ba3d58b0.png";